import { bootstrapApplication } from "@angular/platform-browser";
import { appConfig } from "./app/app.config";
import { AppComponent } from "./app/app.component";
import { installKioskGuards } from "./app/kiosk-guards";
import { captureStationProxy } from "./app/station-proxy";

/**
 * Phase-1 provisioning: capture ?terminalId= from QR-code URL into localStorage,
 * then strip it so the address bar stays clean on subsequent boots.
 *
 * ?stationProxy= (set by the Pi's provisioning) is captured the same way: it routes this kiosk's
 * backend calls through the signing proxy on its own Pi — see station-proxy.ts.
 */
(function captureProvisionedTerminalId(): void {
  const params = new URLSearchParams(window.location.search);
  const tid = params.get('terminalId');
  if (tid) {
    localStorage.setItem('jjames-terminalId', tid);
  }
  const hadProxy = captureStationProxy(params);
  if (tid || hadProxy) {
    const clean = window.location.pathname + window.location.hash;
    window.history.replaceState(null, '', clean);
  }
})();

installKioskGuards();

bootstrapApplication(AppComponent, appConfig).catch((err) =>
  console.error(err),
);
